import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { ReconfigureAgentPanelDataProviderFactory } from '../factory/ReconfigureAgentPanelDataProviderFactory';
import { ReconfigureAgentPanelDataProvider } from '../dataProvider/ReconfigureAgentPanelDataProvider';
import { Feature } from '@nirvana/shared/constants';
import { GetCompaniesFeaturesPayload } from '../../../../utils/request';

export class ReconfigureAgentPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: ReconfigureAgentPanelDataProviderFactory;
  public dataProvider: ReconfigureAgentPanelDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new ReconfigureAgentPanelDataProviderFactory(),
    });
  }

  public async getFeaturesByCompanyIds(payload: GetCompaniesFeaturesPayload): Promise<Feature[]> {
    return this.dataProvider.getFeaturesByCompanyIds(payload);
  }
}
